import { RawHeaderNavigationEntry } from "@/components/layout/header";
import DesktopNavigationEntry from "@/components/layout/header/desktop-navigation-entry";
import { PopoverGroup } from "@headlessui/react";

export default function DesktopNavigationEntries({
  navigationEntries,
}: {
  navigationEntries: RawHeaderNavigationEntry[];
}) {
  let timeout: NodeJS.Timeout | null = null;
  const timeoutDuration = 120;

  function onEntryButtonHover(button: HTMLButtonElement, isOpen: boolean, mode: "enter" | "leave"): void {
    switch (mode) {
      case "enter":
        if (timeout) clearTimeout(timeout);
        if (!isOpen) button.click();
        break;
      case "leave":
        timeout = setTimeout(() => {
          if (isOpen) button.click();
        }, timeoutDuration);
        break;
    }
  }

  return (
    <PopoverGroup className="block w-[43%] self-stretch">
      <div className="flex h-full items-center">
        {navigationEntries.map((navigationEntry, index) => (
          <NavigationEntryMapping
            key={navigationEntry.label + index}
            navigationEntry={navigationEntry}
            index={index}
            onButtonHover={onEntryButtonHover}
          />
        ))}
      </div>
    </PopoverGroup>
  );
}

function NavigationEntryMapping(props: {
  navigationEntry: RawHeaderNavigationEntry;
  index: number;
  onButtonHover: (button: HTMLButtonElement, isOpen: boolean, mode: "enter" | "leave") => void;
}) {
  return (
    <DesktopNavigationEntry
      entry={props.navigationEntry}
      onButtonHover={props.onButtonHover}
      className={props.index === 0 ? "pl-9" : ""}
    />
  );
}
